<div *ngIf="!isEditing && clickToEdit" (click)="startEditing()" class="click-to-edit-area">
    <div *ngIf="initialValue&& initialValue.length > 0; else emptyTester">
        <div *ngFor="let person of initialValue" class="person-list">
          <app-avatar
            [info]="accountData[person]"
            [size]="24"
            class="avatar-container"
            [enable]="accountData[person]?.enable"
          ></app-avatar>
          <span class="person-name">
            {{ accountData[person]?.enable
            ? accountData[person]?.fullName
            : accountData[person]?.fullName + ' (Inactive)' }}
          </span>
          <span
            nz-icon
            nzType="close-circle"
            class="remove-icon"
            (click)="removeAssignee(person, $event)"
          ></span>
        </div>
    </div>
    <ng-template #emptyTester>
        <nz-avatar nzIcon="user" nz-tooltip nzTooltipTitle="Unassigned"></nz-avatar>
    </ng-template>
</div>

<div *ngIf="isEditing || !clickToEdit">
    <nz-select
        #selectComponent
        [(ngModel)]="currentValue"
        [(nzOpen)]="openMenu"
        nzShowSearch
        nzMode="multiple"
        [nzAllowClear]="true"
        style="width: 100%"
        (ngModelChange)="changeSelect($event)"
        (nzOpenChange)="openChange($event)"
        [nzCustomTemplate]="userTemplate"
        [nzDropdownMatchSelectWidth]="false"
    >
        <nz-option *ngFor="let option of projectMembers" [nzValue]="option.value.toString()"
            [nzLabel]="option.label"></nz-option>
    </nz-select>
    <ng-template #userTemplate let-selected>
        <div class="ant-select-selection-item-content">
            {{ getName(selected.nzLabel) }}
        </div>
    </ng-template>
</div>
